module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "not-found"
  }, [_c('div', [_c('h2', {
    staticClass: "not-found__title"
  }, [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("La page que vous cherchez n'existe pas.")]), _vm._v(" "), _c('router-link', {
    staticClass: "not-found__link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Page d'accueil")])], 1), _vm._v(" "), _c('header-nav'), _vm._v(" "), _c('footer-nav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55e390ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/generic/NotFound.vue
// module id = 635
// module chunks = 1